"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotosGetPhotoByIndexNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const Schema = __importStar(require("./schema.json"));
const NODE_TYPE = 'ARRAY-GET-ITEM-BY-INDEX';
const convertToNumber = (val) => {
    let retVal = val;
    try {
        retVal = Number(val);
    }
    catch (e) {
        console.log('Type Conversion error in index');
    }
    finally {
        return retVal;
    }
};
class PhotosGetPhotoByIndexNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this._resolve = (params) => {
            const { array, index } = params;
            const numbIndex = convertToNumber(index);
            return {
                [`output`]: Array.isArray(array) && typeof numbIndex === 'number' && array.length > numbIndex ? array[numbIndex] : undefined,
            };
        };
        this._interfaceDefinition = Schema;
    }
}
exports.PhotosGetPhotoByIndexNode = PhotosGetPhotoByIndexNode;
PhotosGetPhotoByIndexNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Get Photo By Index',
    isIdempotent: true,
    primaryCategory: 'Photo',
};
//# sourceMappingURL=PhotosGetPhotoByIndex.js.map